const DISH_AI_SUGGESTIONS_ENDPOINT = '/menu/dish/predict'

export default DISH_AI_SUGGESTIONS_ENDPOINT
